import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import InlineError from '../../components/common/InlineError';
import { Typography, Button } from "@mui/material";

export const ConsentPage = () => {
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(window.location.search);
  const consentStatus = queryParams.get('status');
  const { t } = useTranslation();

  const handleOnRetryConsent = () => {
    navigate('/data-collection/tasks');
  }

  return (
    <div>
      <Typography variant="h4" component="h1" id="page-heading" tabIndex={-1}>{t('Consent Required')}</Typography>

      <Typography variant="body1" style={{marginTop: '1rem'}}>
        {t('You need to provide consent to participate in the study.')}
      </Typography>

      <Typography variant="body1" style={{marginTop: '1rem'}}>
        {t('Your current consent status is:')} {t(consentStatus || "Unknown")}
      </Typography>
      {consentStatus && consentStatus !== 'Consented' && (
        <InlineError message={t('Consent incomplete. Please finish consent process before proceeding.')} />
      )}

      <Typography variant="body1" style={{marginTop: '1rem'}}>
        {t('If you have just consented, please click on the "Retry" button below.')}
      </Typography>

      <Button variant="contained" style={{marginTop: '1rem'}} onClick={handleOnRetryConsent}>{t('Retry')}</Button>
    </div>
  );
};
